import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.2832 5.29248L21.0003 12.2925L14.2832 19.2925",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("line", {
      x1: "20.6289",
      y1: "12.4014",
      x2: "2.89584",
      y2: "12.4014",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }